<template>
  <vs-popup title="Editar banco" :active.sync="show">
    <div class="card">
      <div class="card-body">
        <form
          v-loading="loading"
          element-loading-text="Guardando..."
          @submit.prevent="store('new-bank')"
          data-vv-scope="new-bank"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Nombre Banco</label>
                <el-input
                  v-model="bank.name"
                  name="name"
                  v-validate="'required'"
                ></el-input>
                <label v-show="errors.has('new-bank.name')" class="error">
                  {{ errors.first("new-bank.name") }}
                </label>
              </div>
            </div>
          </div>

          <div class="text-center mt-30">
            <vs-button button="submit" type="filled">
              Guardar
            </vs-button>
          </div>
        </form>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import utilitiesService from "@/services/utilities.service";

export default {
  props: {
    vis: {
      type: Boolean,
      default: false
    },
    company_id: {
      type: Number
    },
    bankReceived: {
      type: Object,
      default: () => ({})
    }
  },
  name: "edit-bank-modal",
  data() {
    return {
      show: false,
      bank: {
        company_id: "",
        name: ""
      },
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("closeModal", false);
      this.resetDataForm();
    },
    resetDataForm() {
      Object.assign(this.$data.bank, this.$options.data().bank);
      this.$validator.reset();
    },
    store(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let bank = this.bank;
          bank.company_id = this.company_id;
          utilitiesService
            .updateBank(bank)
            .then(res => {
              if (res.data.success) {
                this.$emit("updateBank", res.data.item);
                /*this.$notify({
                title: 'Banco agregada correctamente.',
                type: 'success',
                duration: 1500
              });*/
                //JRA Cambio de notificacion por mensaje
                this.$message({
                  showClose: true,
                  message: "Banco agregada correctamente.",
                  type: "success",
                  duration: 1500
                });
              } else {
                this.close();
                /*this.$notify({
                title: res.data.message,
                type: 'warning'
              });*/
                //JRA Cambio de notificacion por mensaje
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: "warning"
                });
              }
              this.loading = false;
              this.resetDataForm();
            })
            .catch(error => {
              /*this.$notify({
              title: error.message,
              type: 'error'
            });*/
              //JRA Cambio de notificacion por mensaje
              this.$message({
                showClose: true,
                message: error.message,
                type: "error"
              });
              this.loading = false;
            });
        } else {
          /*this.$notify({
              title: 'invalido',
              type: 'error'
            });*/
          //JRA Cambio de notificacion por mensaje
          this.$message({
            showClose: true,
            message: "invalido",
            type: "error"
          });
          this.loading = false;
        }
      });
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.close();
      }
    },
    vis(newVal) {
      this.show = newVal;
    },
    bankReceived(newVal) {
      if (newVal) {
        console.log(newVal);
        this.bank = newVal;
      }
    }
  }
};
</script>

<style scoped>
.el-input-number .el-input .el-input__inner {
  width: 100% !important;
  background: red;
}
.el-date-editor {
  width: 100% !important;
}
.el-input__inner {
  display: block;
  width: 100% !important;
}
.mt-30 {
  margin-top: 30px;
}
</style>
